/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
export type AttempsDTO = {
  id: string;
  ipAddress: string;
  country: string;
  createdAt: string;
};

interface StudentsData {
  data: AttempsDTO[];
  metaData: MetaData;
}

interface StudentsResponse {
  data?: StudentsData;
  error?: ApiError;
}

interface GetStudentsParams {
  page: number;
  limit: number;
  studentId: string;
}

export const GetStudentAttemps = async ({
  studentId,
  page,
  limit,
}: GetStudentsParams): Promise<StudentsResponse> => {
  try {
    const response = await axios.get(`/student/allLoginAttempts/${studentId}`, {
      params: { page, limit },
    });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
